module.exports = __webpack_public_path__ + "img/down.729e2a1e.png";